import { render } from "./AvgCostTotalCard.vue?vue&type=template&id=641c16f4"
import script from "./AvgCostTotalCard.vue?vue&type=script&lang=js"
export * from "./AvgCostTotalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__